import { isValidAlphanumericText, isValidSearchDate } from './Search';

export const isValidFeeRequestNumber = isValidAlphanumericText;
export const isValidRegistrationNumber = isValidAlphanumericText;
export const isValidRequestStatus = isValidAlphanumericText;
export const isValidStartDate = isValidSearchDate;
export const isValidEndDate = isValidSearchDate;
